<!-- 餐厅管理-订单详情 -->

<template>
  <div class="dining-order-details-dialog">
    <w-dialog ref="dialogRef" class="order-info" title="订单详情" width="55%" btnWidth="140px" top="4vh" :hideFooter="true">
      <w-title :title_name="'订单详情'"></w-title>
      <div class="order-content">
        <el-table class="order-table" :data="infoDates.orderdetail" height="200" style="width: 100%" stripe
          tooltip-effect="light" ref="orderTableRef">
          <el-table-column label="商品">
            <template #default="scope">
              <div class="flex">
                <el-image style="width: 40px; height: 40px;margin-right: 10px;" :src="scope.row.drgf_path_text"
                  :preview-src-list="[scope.row.drgf_path_text]" fit="cover">
                </el-image>
                <div>{{ scope.row.drg_name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="odrgd_amount" label="数量"></el-table-column>
          <el-table-column property="odrgd_total" label="商品金额"></el-table-column>
          <el-table-column property="integrate_money" label="积分抵扣金额"></el-table-column>
          <el-table-column property="odrgd_pack_money" label="打包费"></el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <div class="cursor-pointer text-blue" @click="onPartialRefund(scope.row)"
                v-if="scope.row.is_init_refund == 1 && authData.indexOf('r_ZnRkz001PzTFKL7EZ5jroG3Sa6In') != -1">退款
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="order-fee flex-end align-center">
          <div class="order-fee-title">
            <div>打包费：</div>
            <div class="xs-m-t" v-if="infoDates.odrg_receive_way == '1'">配送费：</div>
            <div class="text-blue xs-m-t">总&nbsp&nbsp&nbsp计：</div>
          </div>
          <div class="order-fee-num">
            <div>￥{{ infoDates.odrg_pcharges }}</div>
            <div class="xs-m-t" v-if="infoDates.odrg_receive_way == '1'">￥{{ infoDates.odrg_deliver_fee }}</div>
            <div class="total-num text-blue xs-m-t">￥{{ infoDates.odrg_total }}</div>
          </div>
        </div>
      </div>

      <!-- 积分信息 -->
      <div v-if="integraTable.length !== 0">
        <br />
        <div class="font-black">积分信息</div>
        <common-table ref="integraRef" tableHeight="200" :ispaging="false" :tableData="integraTable" :columns="integraTableColumns">
        </common-table>
      </div>

      <w-title :title_name="'退款详情'"></w-title>
      <common-table ref="refunTableRef" tableHeight="200" :columns="refundColumns" :tableData="infoDates.refun"
        :ispaging="false">
        <template #status="{ row }">
          <div class="status-text" :class="refundStatusColors(row.orr_status, 'color')">
            {{ refundStatusColors(row.orr_status, 'text') }}
          </div>
        </template>
      </common-table>

      <el-row :gutter="20">
        <el-col :span="12">
          <w-title :title_name="'订单信息'"></w-title>
          <div class="flex">
            <div class="catering-infor-title">下单时间</div>
            <div class="catering-infor-content">{{ infoDates.ctime_text }}</div>
          </div>
          <div class="flex">
            <div class="catering-infor-title">订单来源</div>
            <div class="catering-infor-content">{{ infoDates.odrg_source_text }}</div>
          </div>
          <div class="flex">
            <div class="catering-infor-title">下单用户</div>
            <div class="catering-infor-content">{{ infoDates.m_mobile }}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <w-title :title_name="'配送信息'"></w-title>
          <div class="flex">
            <div class="catering-infor-title">配送地址</div>
            <div class="catering-infor-content">{{ infoDates.odrg_address }}</div>
          </div>
          <div class="flex">
            <div class="catering-infor-title">配送时间</div>
            <div class="catering-infor-content">
              <span>{{ infoDates.odrg_prospect_stime_text }}</span>
              <span v-if="infoDates.odrg_prospect_etime_text">至{{ infoDates.odrg_prospect_etime_text }}</span>
            </div>
          </div>
          <div class="flex" v-if="infoDates.odrg_receive_way == '1'">
            <div class="catering-infor-title">配送费用</div>
            <div class="catering-infor-content">{{ infoDates.odrg_deliver_fee }}</div>
          </div>
        </el-col>
      </el-row>

      <div v-if="infoDates.odrg_remarks">
        <w-title :title_name="'备注'"></w-title>
        <div>{{ infoDates.odrg_remarks }}</div>
      </div>
    </w-dialog>

    <!-- 退款 -->
    <PartialRefund ref="refundRef" @submit="handleSureRefund"></PartialRefund>
  </div>
</template>

<script>
import { ref, computed, watch, nextTick, } from "vue";
import { ElMessage, } from "element-plus";
import { DinnerApi, } from "@/plugins/api.js";
import { useStore } from "vuex";
import PartialRefund from "./PartialRefund.vue";

export default {
  emits: ["submit"],
  components: { PartialRefund, },
  setup(props, { emit }) {
    const store = useStore();
    const menuTokens = computed(() => store.state.menuToken.menuTokens);
    const authData = ref([]);
    watch(
      () => menuTokens.value,
      (data) => {
        if (data.length) {
          authData.value = data;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前行数据
    const infoDates = ref([]);  // 详情数据
    const refunTableRef = ref(null);  // 退款表格对象
    const refundColumns = ref([
      {
        prop: "drg_name",
        label: "退款商品",
      },
      {
        prop: "drg_amount",
        label: "退款数量",
      },
      {
        prop: "drg_odrgd_total",
        label: "商品金额",
      },
      {
        prop: "integrate_money",
        label: "积分退回金额",
      },
      {
        prop: "odrr_pack_total",
        label: "打包费",
      },
      {
        prop: "refund_total",
        label: "退款合计",
      },
      {
        prop: "status",
        label: "退款状态",
        type: "customRender",
        minWidth: 120,
      },
    ]);
    const refundRef = ref(null);  // 部分退款对象
    const integraRef = ref(null);
    const integraTable = ref([]);
    const integraTableColumns = ref([
      {
        prop: "mi_type_label",
        label: "积分类型",
      },
      {
        prop: "mi_source_label",
        label: "积分说明",
      },
      {
        prop: "mi_integration",
        label: "积分数量",
      },
      {
        prop: "mi_adder",
        label: "发起人",
      },
      {
        prop: "created_at",
        label: "发起时间",
      },
    ]);
    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      currentRow.value = row;
      getDetails();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 打开对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }
    /**
     * 
     * 获取详情数据
     * 
     * **/
    const getDetails = () => {
      DinnerApi.getDinnerOrderInfo({ odrg_id: currentRow.value.odrg_id }).then((res) => {
        if (res.Code === 200) {
          infoDates.value = res.Data;
          integraTable.value = res.Data.integration_record || [];
          dialogRef.value.show();
          nextTick(() => {
            refunTableRef.value.tableLoad();
            if (integraTable.value.length != 0) {
              integraRef.value.tableLoad();
            }
          });
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    /**
     * 
     * 部分退款按钮
     * 
     * **/
    const onPartialRefund = (row) => {
      refundRef.value.openDialog(row);
    }
    /**
     * 
     * 退款状态
     * 
     * **/
    const refundStatusColors = (status, type) => {
      let status_text = '';  // 状态（ 0-等待后台审核 1-退款中 2-已退款 3-退款失败 4取消退款订单 5拒绝退款 6人工退款已完成）
      let status_color = '';
      switch (status) {
        case 0:
          status_text = '待审核';
          status_color = 'btn-blue';
          break;
        case 1:
          status_text = '退款中';
          status_color = 'btn-yellow';
          break;
        case 2:
          status_text = '已退款';
          status_color = 'btn-black';
          break;
        case 3:
          status_text = '退款失败';
          status_color = 'btn-red';
          break;
        case 4:
          status_text = '取消退款';
          status_color = 'btn-grey';
          break;
        case 5:
          status_text = '拒绝退款';
          status_color = 'btn-red';
          break;
        case 6:
          status_text = '人工退款已完成';
          status_color = 'btn-orange';
          break;
      }

      if (type == 'text') {
        return status_text;
      } else {
        return status_color;
      }
    }
    /**
     * 
     * 部分退款提交按钮
     * 
     * **/
    const handleSureRefund = (data) => {
      const parmas = {
        sn: currentRow.value.or_sn,
        ...data,
      };
      DinnerApi.dinnerInitiateRefund(parmas).then((res) => {
        refundRef.value.closeDialogLoading();
        if (res.Code === 200) {
          refundRef.value.closeDialog();
          getDetails();
          emit('submit');
          ElMessage.success("操作成功");
        } else {
          ElMessage.error(res.Message);
        }
      });
    }


    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      getDetails,
      infoDates,
      authData,
      refundColumns,
      onPartialRefund,
      refundRef,
      refundStatusColors,
      handleSureRefund,
      refunTableRef,
      integraRef,
      integraTable,
      integraTableColumns,
    };
  },
};
</script>

<style lang="scss">
.dining-order-details-dialog {
  
  .el-dialog__body {
      height: 740px;
      overflow: auto;
    }
}
</style>